export default "__VITE_ASSET__CRkgtQMH__"